import {
  Button,
  DialogActions,
  DialogContent,
  Grid,
  MenuItem,
  Paper,
  Typography,
} from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import InputImage from "../../../components/InputImage";
import InputSelectSearch from "../../../components/InputSelectSearch";
import { getCurrencySymbols } from "../../../components/Utils/Currency";
import propertyStore from "../../../Store/PropertyStore";
import pickupStore from "../../../Store/PickupStore";
import { DialogTitle } from "@material-ui/core";
import InputTextareaEditor from "../../../components/InputTextareaEditor";
import { alert } from "../../../components/AlertDialog";
import { Modal } from "reactstrap";
import { Loader } from "@googlemaps/js-api-loader";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
  root: {
    "& .MuiFormLabel-root": {
      fontSize: "13px",
      color: "#9B9B9B",
    },
  },
});

function Form(props) {
  const { classes, width, title, data, cancel, handleGetPickupPointList } =
    props;
  const [openDialog, setOpenDialog] = React.useState(true);
  const [propertyState, propertyActions] = propertyStore();
  const [pickupState, pickupActions] = pickupStore();
  const [state, setState] = React.useState({
    formData: {
      id: "",
      name: "",
      property_id: "",
      floor: "",
      latitude: "",
      longitude: "",
      description: "",
      image_url: "",
      type: "",
    },
  });
  const [optionsCurrency, setOptionsCurrency] = React.useState([]);
  const user = JSON.parse(localStorage.getItem("user"));

  const handleCloseDialog = () => {
    setState({
      formData: {
        id: "",
        name: "",
        property_id: "",
        floor: "",
        latitude: "",
        longitude: "",
        description: "",
        image_url: "",
        type: "",
      },
    });
    setOpenDialog(false);
  };

  const handleSubmit = (event) => {
    if (state.formData.image_url === "") {
      alert("Warning", `Please upload image for pickup point`);
    } else {
      confirm("Submit", "Are you sure to Submit ?").then(async (onProcess) => {
        if (props.data === null) {
          const { formData } = state;
          await pickupActions.store(formData);
          handleCloseDialog();
          handleGetPickupPointList(true);
          cancel();
        } else {
          const { formData } = state;
          await pickupActions.put(formData, data.id);
          handleGetPickupPointList(true);
          handleCloseDialog();
          cancel();
        }
      });
    }
  };

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = ["bold", "italic", "underline", "list", "bullet"];

  React.useEffect(() => {
    const arrCurrency = getCurrencySymbols();
    setOptionsCurrency(
      arrCurrency.map((row) => ({
        value: row.code,
        name: `${row.code} (${row.symbol})`,
      }))
    );
    if (data) {
      setState({
        formData: {
          id: data.id,
          property_id: data.property.id,
          name: data.name,
          floor: data.floor,
          latitude: data.latitude,
          longitude: data.longitude,
          description: data.description,
          image_url: data.image_url,
          type: data.type,
        },
      });
    }
  }, [data]);

  return (
    <CustomizedDialogs
      disableBackdropClick
      maxWidth={width !== "xs" ? "md" : false}
      fullScreen={width === "xs"}
      title={props.title}
      scroll="body"
      open={openDialog}
      HiddenCloseIcon={true}
    >
      <DialogContent classes={{ root: classes.content }}>
        <ValidatorForm
          id="myform"
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <Paper className={classes.root} style={{ boxShadow: "none" }}>
            <Grid container>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: "bolder", fontSize: 18 }}
                gutterBottom
              >
                Create Pickup Point
              </Typography>
              <Grid item xs={12}>
                <SelectValidator
                  id="type"
                  name="type"
                  label="Pickup Point Type"
                  className={classes.textField}
                  margin="normal"
                  value={state.formData.type}
                  validators={["required"]}
                  errorMessages={["Pickup Point Type is required"]}
                  onChange={handleChange}
                  autoFocus
                >
                  <MenuItem value="customer">
                    Pickup Point for Customer
                  </MenuItem>
                  <MenuItem value="courier">Pickup Point for Courier</MenuItem>
                </SelectValidator>
                <TextValidator
                  id="name"
                  label="Pickup Point Location Name"
                  name="name"
                  className={classes.textField}
                  margin="normal"
                  value={state.formData.name}
                  type="text"
                  inputProps={{ maxLength: 100 }}
                  helperText={
                    <span
                      style={{ textAlign: "right", display: "block" }}
                    >{`${state.formData.name.length}/100`}</span>
                  }
                  validators={["required", "maxStringLength:100"]}
                  errorMessages={[
                    "Name is required",
                    "maximum character is 100",
                  ]}
                  onChange={handleChange}
                />
                <TextValidator
                  id="description"
                  label="Add Description"
                  name="description"
                  className={classes.textField}
                  margin="normal"
                  value={state.formData.description}
                  type="text"
                  helperText={
                    <span
                      style={{ textAlign: "right", display: "block" }}
                    >{`${state.formData.description.length}/100`}</span>
                  }
                  validators={["required", "maxStringLength:100"]}
                  errorMessages={[
                    "Description is required",
                    "Maximum character is 100",
                  ]}
                  onChange={handleChange}
                  multiline
                />
                <Grid container>
                  <Grid item xs={4}>
                    <TextValidator
                      id="floor"
                      label="Floor example : Level 1"
                      name="floor"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.floor}
                      type="text"
                      inputProps={{ maxLength: 25 }}
                      helperText={
                        <span
                          style={{ textAlign: "right", display: "block" }}
                        >{`${state.formData.floor.length}/25`}</span>
                      }
                      validators={["required", "maxStringLength:25"]}
                      errorMessages={[
                        "Flor is required",
                        "maximum character is 25",
                      ]}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextValidator
                      id="latitude"
                      label="Latitude example: -7.275973"
                      name="latitude"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.latitude}
                      type="text"
                      inputProps={{ maxLength: 100 }}
                      helperText={
                        <span
                          style={{ textAlign: "right", display: "block" }}
                        >{`${state.formData.latitude.length}/100`}</span>
                      }
                      validators={["required"]}
                      errorMessages={["Latitude is required"]}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextValidator
                      id="longitude"
                      label="Longitude example: 112.808304"
                      name="longitude"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.longitude}
                      type="text"
                      inputProps={{ maxLength: 100 }}
                      helperText={
                        <span
                          style={{ textAlign: "right", display: "block" }}
                        >{`${state.formData.longitude.length}/100`}</span>
                      }
                      validators={["required"]}
                      errorMessages={["Longitude is required"]}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
                <InputImage
                  image={state.formData.image_url}
                  maxSize={1000}
                  aspectW={16}
                  aspectH={9}
                  removeType="reset"
                  onUploadDone={(url) => {
                    const { formData } = state;
                    formData.image_url = url;
                    setState({ formData });
                  }}
                  onRemove={(url) => {
                    const { formData } = state;
                    formData.image_url = "";
                    setState({ formData });
                  }}
                  style={{
                    marginTop: "0px !important",
                    width: "100%",
                    height: 240,
                    maxWidth: "100%",
                    maxHeight: 240,
                  }}
                  styleWrapper={{
                    borderColor: "#BDBDBD",
                    borderRadius: 0,
                  }}
                  styleImage={{ height: 240, width: "auto" }}
                />
                <p
                  style={{
                    fontSize: 10,
                    color: "#757575",
                    lineHeight: 1,
                  }}
                >
                  JPEG or 32-bit PNG
                  <br />
                  512 px by 512 px
                  <br />
                  Up to 1 MB
                </p>
              </Grid>
            </Grid>
          </Paper>
        </ValidatorForm>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleCloseDialog();
          }}
          style={{
            color: "#BDBDBD",
            fontSize: 13,
            textTransform: "capitalize",
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          form="myform"
          variant="contained"
          style={{
            backgroundColor: "#2196F3",
            color: "#FFFFFF",
            fontSize: 13,
            marginRight: 30,
            borderRadius: 0,
            boxShadow: "none",
            textTransform: "capitalize",
          }}
        >
          Save
        </Button>
      </DialogActions>
    </CustomizedDialogs>
  );
}

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
  handleGetPickupPointList: PropTypes.func,
};
export function showForm(title, data, handleGetPickupPointList, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      handleGetPickupPointList,
      ...options,
    }
  );
}
